import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

export const IncreasedOddsIcon = ({ className }) => {
  const { t } = useI18n();

  return (
    <Icon
      name="icons/general/item/increased_coefficient"
      size="l"
      color="accent_color_3"
      title={t('sportsbook.market.increasedOdds')}
      className={className}
    />
  );
};
